import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from "@/components/layout/index.vue";
import store from '../store';
import * as commonFun from '@/utils/function.js';

Vue.use(VueRouter)

const modulesFiles = require.context('./modules', true, /\.js$/)
let module = [];
modulesFiles.keys().reduce((modules, modulePath) => {
    const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
    const value = modulesFiles(modulePath);
    value.default.forEach(function(item, index) {
        module.push(item);
    })
}, {})

// 重复点击异常
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}


const routes = [{
        path: "/",
        redirect: "/home"
    }, {
        path: '/login',
        name: 'login',
        meta: {
            title: "商户登录"
        },
        component: () =>
            import ('@/views/login/index'),
    }, {
        path: "*",
        redirect: "/home"
    }, {
        path: '/',
        name: 'Layout',
        component: Layout,
        meta: {
            title: "首页"
        },
        children: [{
            path: "home",
            name: "home",
            component: () =>
                import ('@/views/index'),
            meta: {
                title: '后台系统'
            }
        }]
    },
    {
        path: '/order',
        component: Layout,
        children: [{
            path: '/order',
            name: 'order',
            meta: {
                title: "订单管理"
            },
            component: () =>
                import ('@/views/order/order.vue'),
        }, ]

    },
    ...module
]

const router = new VueRouter({
    routes,
})

router.beforeEach((to, form, next) => {
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    const token = store.state.app.merchantAccessToken
    if (to.path == '/login') {
        if (token) {
            next('/home')
        } else {
            next()
            localStorage.clear()
        }
    } else {
        if (token) {
            next();
        } else {
            let options = commonFun.getUrlParam();
            if (options.auth_code) {
                next();
            } else {
                next('/login')
                localStorage.clear()
            }
        }
    }
});
export default router